import { useEsigningProviders } from 'app/domains/esigning/hooks/useEsigningProviders';
import { getEsigningProviderMetadataByProviderId } from 'app/domains/esigning/utils';
export function useEsigningProviderMetadata() {
    const { connectedProvider } = useEsigningProviders();
    const metadata = getEsigningProviderMetadataByProviderId(connectedProvider === null || connectedProvider === void 0 ? void 0 : connectedProvider.id);
    return metadata;
}
